export default "__VITE_ASSET__joIjf5KH__"